module.exports = __webpack_public_path__ + "img/HOME-2.15c695a7.png";